document.addEventListener('DOMContentLoaded', function () {
	const navMobile = document.querySelector('.nav-mobile');

	// Créer et insérer le bouton burger avant le menu
	const navToggle = document.createElement('button');
	navToggle.className = 'nav-toggle';
	navToggle.setAttribute('aria-label', 'Menu');
	navToggle.setAttribute('aria-expanded', 'false');
	navToggle.innerHTML = `
     <span class="burger-icon">
       <svg xmlns="http://www.w3.org/2000/svg" width="34" height="23" viewBox="0 0 34 23" fill="none">
         <line y1="1.5" x2="34" y2="1.5" stroke="currentColor" stroke-width="3"/>
         <line y1="11.5" x2="34" y2="11.5" stroke="currentColor" stroke-width="3"/>
         <line y1="21.5" x2="34" y2="21.5" stroke="currentColor" stroke-width="3"/>
       </svg>
     </span>
     <span class="close-icon">
       <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
         <path fill="currentColor" d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z"/>
       </svg>
     </span>
   `;
	navMobile.parentNode.insertBefore(navToggle, navMobile);

	// Créer et insérer l'overlay après le menu
	const navOverlay = document.createElement('div');
	navOverlay.className = 'nav-overlay';
	navMobile.parentNode.insertBefore(navOverlay, navMobile.nextSibling);

	function toggleMenu() {
		const isOpen = navMobile.classList.contains('is-active');
		navMobile.classList.toggle('is-active');
		navOverlay.classList.toggle('is-active');
		navToggle.setAttribute('aria-expanded', !isOpen);
		document.body.classList.toggle('menu-open', !isOpen);
	}

	navToggle.addEventListener('click', toggleMenu);
	navOverlay.addEventListener('click', toggleMenu);

	// Solution spécifique pour gérer les liens d'ancrage sur Safari iOS
	// Capturer tous les clics sur des liens dans le menu
	navMobile.addEventListener('click', function (event) {
		// Vérifier si l'élément cliqué ou un de ses parents est un lien
		const clickedLink = event.target.closest('a');

		if (clickedLink && navMobile.classList.contains('is-active')) {
			// Pour les liens d'ancrage (#) sur Safari iOS, nous devons gérer différemment
			if (clickedLink.getAttribute('href').startsWith('#')) {
				// Fermer le menu
				toggleMenu();
			} else {
				// Pour les liens normaux, fermer simplement le menu après un court délai
				setTimeout(toggleMenu, 50);
			}
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && navMobile.classList.contains('is-active')) {
			toggleMenu();
		}
	});
});